import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { useFormNew } from "../../../../hooks/useFormNew"
import { Button, Grid } from "@material-ui/core"
import { useMesaEntrada } from "../../../../hooks/useCases/useMesaEntrada"

export const ModalRechazoComprobante = ({ idComprobante, cancelar }) => {
    const { formValues, handleInputChange } = useFormNew({ motivo: "" })
    const { put } = useMesaEntrada();
    const handleSubmit = () => put.rechazarComprobanteDirecto({idComprobante, motivo: formValues.motivo}, cancelar)
    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextValidator
                        value={formValues.motivo}
                        onChange={handleInputChange}
                        fullWidth
                        label="Motivo"
                        name="motivo"
                        autoComplete={"off"}
                        multiline
                        validators={["required"]}
                        errorMessages={["El motivo de rechazo es requerido"]}
                    />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em" }}>
                    <Button color="secondary" variant="contained" onClick={cancelar}>CANCELAR</Button>
                    <Button color="primary" variant="contained" type="submit">CONFIRMAR</Button>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
